export const FETCH_CUSTOMER_DETAILS_LIST = "FETCH_CUSTOMER_DETAILS_LIST";
